import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setNewDataValue, fetchPaymentInfo, fetchPlanData } from 'alelo-logic/actions'

import { Flex, Box } from 'grid-styled'

import EditPaymentForm from '../../modules/EditPaymentForm'
import RechargeBreadcrumbs from '../../modules/RechargeBreadcrumbs'
import rem from '../../../styles/tools/rem'

import { showModal } from '../../modules/ModalRoot/actions'
import image from '../../../static/confirmation.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import {
  Text,
  RechargeValue,
  Cash,
  CashPrefix,
  CashValue,
  TitlePayment,
  BoxPayment
} from './styles'

import { rechargeValueLabel, currency, titleModalError, valueLabel } from './data.json'

import {
  getBrasPagAccessToken,
  postBraspagCard
} from '../../../alelo-logic/services/rechargeService'

import { validateCreditCardFlag } from '../../modules/EditPaymentForm/validators'

class RechargePayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      maskedNumber: '',
      loading: false,
      valorRecarga: ''
    }
  }

  async componentDidMount() {
    await this.props.getPaymentInfo(this.props.match.params.id)
    const plan = this.props.accountPlans.plans.find(this.applyFilter)

    if (this.props.location.search.includes('path=track')) {
      await this.props.fetchPlanData(plan).then(() => {
        this.setState({ valorRecarga: this.props.planData.recharge })
      })
    } else {
      this.setState({ valorRecarga: this.props.recharge.currentRechargeValue })
    }
  }

  applyFilter = checkPlan =>
    checkPlan.id.toString() === this.props.accountPlans.activePlanId.toString()

  resolverTipoCompra = () => {
    return window.location.href.includes('/empresa') ? 'compra-pj' : 'compra'
  }

  getPaymentToken = async values => {
    var paymentToken
    await getBrasPagAccessToken()
      .then(async response => {
        const resp = await postBraspagCard(
          this.formatCardHolderName(values.yourName),
          values.cardNumber.replace(/\s/g, ''),
          values.validad,
          values.securityCode,
          response.data
        )
        paymentToken = resp.data
      })
      .catch(error => console.error(error))
    return paymentToken
  }

  checkCreditCardFlag = values => {
    const creditCardFlag = validateCreditCardFlag(values)
    if (creditCardFlag) {
      return creditCardFlag
    }
  }

  formatCardHolderName = name => {
    return name
      .toUpperCase()
      .replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A')
      .replace(new RegExp('[ÉÈÊ]', 'gi'), 'E')
      .replace(new RegExp('[ÍÌÎ]', 'gi'), 'I')
      .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O')
      .replace(new RegExp('[ÚÙÛ]', 'gi'), 'U')
      .replace(new RegExp('[Ç]', 'gi'), 'C')
  }

  cardErrorModalButtonClick = () => {
    this.setState({ showCardErrorModal: false })
  }

  onConfirm = async (evt, values) => {
    const { location: { search } } = this.props
    this.setState({ loading: true })

    if (
      (values && values.paymentMethod === 'Adicionar um novo cartão') ||
      location.search.includes('path=track') ||
      location.search.includes('path=recharge')
    ) {
      const { PaymentToken: paymentToken } = await this.getPaymentToken(values)
      if (!paymentToken) {
        this.setState({ loading: false })
        this.props.showErrorModal()
      } else {
        const data = {
          dados: {
            conta: this.props.match.params.id,
            numeroMascarado: (
              values.cardNumber.substring(0, 7) +
              'XX-XXXX-' +
              values.cardNumber.substring(15)
            ).replace(/\s/g, '-'),
            validade: values.validad.replace('/', '-'),
            bandeira: this.checkCreditCardFlag(values.cardNumber.replace(/\s/g, '')),
            alias: 'EDICAO FORMA PAGAMENTO',
            nome: this.formatCardHolderName(values.yourName),
            paymentToken: paymentToken,
            cvv: values.securityCode,
            valorRecarga: this.state.valorRecarga
          }
        }

        this.props
          .handleSave(data)
          .then(async resp => {
            await this.props.getPaymentInfo(this.props.match.params.id)
            this.setState({ loading: false })

            let msgRecarga =
              resp && resp.result.msgRecarga
                ? `&msgrecarga=${resp.result.msgRecarga}`
                : '&msgrecarga=Vimos que você estava com saldo menor e ja atualizamos seu saldo!'

            if (search.includes('path=recharge') || search.includes('path=track')) {
              this.props.history.push(
                `/minha-veloe/${
                  this.props.match.params.id
                }/editar-dados/sucesso${search}${msgRecarga}`
              )
            } else {
              this.props.history.push(
                `/minha-veloe/${
                  this.props.match.params.id
                }/editar-dados/sucesso-automatico?path=edit${msgRecarga}`
              )
            }
          })
          .catch(async e => {
            console.error(e) // eslint-disable-line
            await this.props.getPaymentInfo(this.props.match.params.id)
            this.setState({ loading: false })
            this.props.showErrorModal()
          })
      }
    } else {
      await this.props.getPaymentInfo(this.props.match.params.id)
      this.setState({ loading: false })
      if (search.includes('path=recharge')) {
        this.props.history.push(
          `/minha-veloe/${this.props.match.params.id}/editar-dados/sucesso${search}`
        )
      } else {
        this.props.history.push(
          `/minha-veloe/${this.props.match.params.id}/editar-dados/sucesso-automatico`
        )
      }
    }
  }

  formatCurrencyRecharge = value => {
    if (!isNaN(value)) {
      return parseFloat(value)
    }
  }

  render() {
    const { match: { params: { id } }, location, location: { search } } = this.props

    return (
      <section>
        <RechargeBreadcrumbs active={2} />
        <Flex direction={['column', 'row']} justify="space-between">
          <Box mr={[0, `${1 / 12 * 100}%`]} mb={rem('20px')} width={[1, 4 / 12]}>
            <RechargeValue>
              {search.includes('path=recharge') ? (
                <Text>{valueLabel}</Text>
              ) : (
                <Text>{rechargeValueLabel}</Text>
              )}

              <Cash>
                <CashPrefix>{currency}</CashPrefix>
                <CashValue id="lblCurrentRechargeValue" bigValue={this.state.valorRecarga > 1000}>
                  {this.state.valorRecarga}
                </CashValue>
              </Cash>
            </RechargeValue>
          </Box>
          <BoxPayment width={[1, 6 / 12]}>
            {search.includes('path=recharge') || search.includes('path=track') ? (
              <TitlePayment>Inserir um novo cartão para sua recarga?</TitlePayment>
            ) : (
              <TitlePayment>Inserir um novo cartão para sua recarga automática?</TitlePayment>
            )}
            <EditPaymentForm
              paymentInfo
              loading={this.state.loading}
              onSubmit={this.onConfirm}
              id={id}
              location={location}
            />
          </BoxPayment>
        </Flex>
      </section>
    )
  }
}

const mapStateToProps = ({ reducer }) => {
  return {
    recharge: reducer.recharge,
    account: reducer.account,
    activePlanId: reducer.accountPlans.activePlanId,
    accountPlans: reducer.accountPlans,
    planData: reducer.planData
  }
}

const mapDispatchToProps = dispatch => ({
  getPaymentInfo: accountPlanId => fetchPaymentInfo(accountPlanId)(dispatch),
  handleSave: data => dispatch(setNewDataValue(data)),
  showErrorModal: () => dispatch(showModal(CONFIRM_UPDATE, { modalTitle: titleModalError, image })),
  fetchPlanData: plano => dispatch(fetchPlanData(plano))
})

export default connect(mapStateToProps, mapDispatchToProps)(RechargePayment)



// WEBPACK FOOTER //
// ./src/app/pages/EditPaymentCreditCard/index.js